// @generated by protoc-gen-es v1.10.1 with parameter "target=dts+js"
// @generated from file agent/livekit_agent_session.proto (package livekit.agent, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum livekit.agent.ChatRole
 */
export const ChatRole = /*@__PURE__*/ proto3.makeEnum(
  "livekit.agent.ChatRole",
  [
    {no: 0, name: "DEVELOPER"},
    {no: 1, name: "SYSTEM"},
    {no: 2, name: "USER"},
    {no: 3, name: "ASSISTANT"},
  ],
);

/**
 * @generated from message livekit.agent.MetricsReport
 */
export const MetricsReport = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.MetricsReport",
  () => [
    { no: 1, name: "started_speaking_at", kind: "message", T: Timestamp },
    { no: 2, name: "stopped_speaking_at", kind: "message", T: Timestamp },
    { no: 3, name: "transcription_delay", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 4, name: "end_of_turn_delay", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 5, name: "on_user_turn_completed_delay", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 6, name: "llm_node_ttft", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 7, name: "tts_node_ttfb", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 8, name: "e2e_latency", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
  ],
);

/**
 * @generated from message livekit.agent.ChatMessage
 */
export const ChatMessage = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.ChatMessage",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "role", kind: "enum", T: proto3.getEnumType(ChatRole) },
    { no: 3, name: "content", kind: "message", T: ChatMessage_ChatContent, repeated: true },
    { no: 4, name: "interrupted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "transcript_confidence", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 6, name: "extra", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 7, name: "metrics", kind: "message", T: MetricsReport },
    { no: 8, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message livekit.agent.ChatMessage.ChatContent
 */
export const ChatMessage_ChatContent = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.ChatMessage.ChatContent",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "payload" },
  ],
  {localName: "ChatMessage_ChatContent"},
);

/**
 * @generated from message livekit.agent.FunctionCall
 */
export const FunctionCall = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.FunctionCall",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "call_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "arguments", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message livekit.agent.FunctionCallOutput
 */
export const FunctionCallOutput = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.FunctionCallOutput",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "call_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "output", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "is_error", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message livekit.agent.AgentHandoff
 */
export const AgentHandoff = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.AgentHandoff",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "old_agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "new_agent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message livekit.agent.ChatContext
 */
export const ChatContext = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.ChatContext",
  () => [
    { no: 1, name: "items", kind: "message", T: ChatContext_ChatItem, repeated: true },
  ],
);

/**
 * @generated from message livekit.agent.ChatContext.ChatItem
 */
export const ChatContext_ChatItem = /*@__PURE__*/ proto3.makeMessageType(
  "livekit.agent.ChatContext.ChatItem",
  () => [
    { no: 1, name: "message", kind: "message", T: ChatMessage, oneof: "item" },
    { no: 2, name: "function_call", kind: "message", T: FunctionCall, oneof: "item" },
    { no: 3, name: "function_call_output", kind: "message", T: FunctionCallOutput, oneof: "item" },
    { no: 4, name: "agent_handoff", kind: "message", T: AgentHandoff, oneof: "item" },
  ],
  {localName: "ChatContext_ChatItem"},
);

